<template>
  <div>
    <v-card>
      <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
        <v-tab v-for="item in tabItems" :key="item" name="item" @click="tabInfo(item)">{{ item }}</v-tab>
      </v-tabs>
    </v-card>
    <ApprovalInvoice v-if="tab == 0" />
    <HistoryInvoice v-if="tab == 1" />
  </div>
</template>
<script>
import ApprovalInvoice from "@/components/InvoiceSubfolder/ApprovalInvoice.vue";
import HistoryInvoice from "@/components/InvoiceSubfolder/HistoryInvoice.vue";

export default {
  components: {
    ApprovalInvoice,
    HistoryInvoice
  },
  data: () => ({
    tab: 0,
    tabItems: ["Approval", "History"]
  }),
  methods: {}
};
</script>